import { propertiesTypes } from '@/reports/types';
import { commaFormatCurrency } from '@/utils/commaFormat/commaFormatCurrency';

export function formatTaxesOfProperty(rawProperty: propertiesTypes.Property) {
  return [
    [
      'Tax Amount',
      commaFormatCurrency(rawProperty?.taxes?.bills?.[0].amount) || '-',
    ],
  ];
}
